// ============================================================
//  Qbrix Hobby — Collection + Product page JS
//  Requires: qbrix-theme.js (qbxTrack must be available)
// ============================================================

function poWaMask(input) {
  var v = input.value.replace(/\D/g, '');
  if (v.startsWith('0'))  v = v.slice(1);
  if (v.startsWith('62')) v = v.slice(2);
  v = v.slice(0, 13);
  var f = v;
  if (v.length > 3 && v.length <= 7) f = v.slice(0, 3) + ' ' + v.slice(3);
  if (v.length > 7) f = v.slice(0, 3) + ' ' + v.slice(3, 7) + ' ' + v.slice(7);
  input.value = f;
}

document.addEventListener('DOMContentLoaded', function() {

  // ── COLLECTION PAGE ─────────────────────────────────────
  if (document.getElementById('hbc-product-grid')) {
    hbcShuffleGrid();
    hbcTagPositions();    // set data-position after shuffle
    hbcInitMoodFilter();
    hbcInitTickerClone();
    hbcInitPreorderModal();
    hbcInitObservers();
    hbcTrackCollectionView();
  }

  // ── PRODUCT PAGE ─────────────────────────────────────────
  if (document.getElementById('po-btn-open') || document.querySelector('.hbp-gallery-main')) {
    hbpInitGallery();
    hbpInitFloatingCta();
    hbpInitBreadcrumbs();
    hbpInitTicker();
    hbpInitFeatAnim();
    hbpInitPreorder();
    hbpInitRelated();
    hbpInitHdrObserve();
    hbpInitBuyNow();
    hbpTrackHobbyView();
    hbpParseDescription();
  }

});

// ── COLLECTION PAGE FUNCTIONS ────────────────────────────────

function hbcShuffleGrid() {
  var grid = document.getElementById('hbc-product-grid');
  if (!grid) return;
  var cards = Array.from(grid.querySelectorAll('.hbc-card-wrap'));
  for (var i = cards.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    // Fisher-Yates DOM swap
    var nodeA = cards[i];
    var nodeB = cards[j];
    var nextA = nodeA.nextSibling;
    var nextB = nodeB.nextSibling;
    if (nextA === nodeB) {
      grid.insertBefore(nodeB, nodeA);
    } else if (nextB === nodeA) {
      grid.insertBefore(nodeA, nodeB);
    } else {
      grid.insertBefore(nodeB, nextA);
      grid.insertBefore(nodeA, nextB);
    }
  }
}

function hbcTagPositions() {
  var grid = document.getElementById('hbc-product-grid');
  if (!grid) return;
  var cards = grid.querySelectorAll('.hbc-card-wrap');
  cards.forEach(function(card, index) {
    card.setAttribute('data-position', index);
  });
}

function hbcBrickPop(el) {
  if (!el) return;
  el.classList.remove('hbc-popping');
  // Trigger reflow to restart animation
  void el.offsetWidth;
  el.classList.add('hbc-popping');
  el.addEventListener('animationend', function handler() {
    el.classList.remove('hbc-popping');
    el.removeEventListener('animationend', handler);
  });
}

function hbcScrollToGrid() {
  var target = document.getElementById('hbc-catalog');
  if (!target) return;
  var nav = document.getElementById('main-nav');
  var navH = nav ? nav.offsetHeight : 64;
  var topbar = document.getElementById('utm-topbar');
  var topbarH = (topbar && topbar.offsetParent) ? topbar.offsetHeight : 0;
  var offset = target.getBoundingClientRect().top + window.pageYOffset - navH - topbarH - 16;
  window.scrollTo({ top: offset, behavior: 'smooth' });
}

function hbcInitMoodFilter() {
  var moodCards = document.querySelectorAll('#hbc-mood-cards .hbc-mood-card');
  var productCards = document.querySelectorAll('#hbc-product-grid .hbc-card-wrap');
  if (!moodCards.length) return;

  moodCards.forEach(function(card) {
    card.addEventListener('click', function() {
      var mood = card.getAttribute('data-mood');

      // Update active card state
      moodCards.forEach(function(c) { c.classList.remove('hbc-active'); });
      card.classList.add('hbc-active');

      // Animate brick indicator
      var brickInd = card.querySelector('.hbc-brick-ind');
      if (brickInd) hbcBrickPop(brickInd);

      // Analytics
      if (typeof qbxTrack === 'function') {
        qbxTrack('hobby_mood_filter', { mood: mood });
      }

      // Filter product cards + reorder
      var grid = document.getElementById('hbc-product-grid');
      var allCards = Array.from(grid.querySelectorAll('.hbc-card-wrap'));

      if (mood === 'all') {
        allCards.sort(function(a, b) {
          return parseInt(a.getAttribute('data-position') || '0', 10) -
                 parseInt(b.getAttribute('data-position') || '0', 10);
        });
        allCards.forEach(function(card) { grid.appendChild(card); });
      } else {
        var matched = allCards.filter(function(c) {
          var cardMood = c.getAttribute('data-mood') || '';
          return cardMood === 'all' || cardMood.split(' ').indexOf(mood) !== -1;
        });
        var unmatched = allCards.filter(function(c) {
          return matched.indexOf(c) === -1;
        });
        matched.concat(unmatched).forEach(function(card) {
          grid.appendChild(card);
        });
        setTimeout(function() { hbcScrollToGrid(); }, 100);
      }
    });
  });

  // Wire card click analytics
  productCards.forEach(function(wrap) {
    wrap.addEventListener('click', function(e) {
      if (typeof qbxTrack === 'function') {
        qbxTrack('hobby_card_click', {
          product_id: wrap.querySelector('[data-product-id]') ? wrap.querySelector('[data-product-id]').getAttribute('data-product-id') : '',
          position: parseInt(wrap.getAttribute('data-position') || '0', 10)
        });
      }
    });
  });
}

function hbcInitTickerClone() {
  var track = document.querySelector('.hbc-ticker-track');
  if (!track) return;
  var group = track.querySelector('.hbc-ticker-group');
  if (group && !track.dataset.cloned) {
    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
    track.dataset.cloned = 'true';
  }
}

function hbcInitPreorderModal() {
  var modal = document.getElementById('hbc-modal');
  if (!modal) return;

  var currentProductName = '';
  var currentProductId = '';

  // Open modal on any preorder trigger click
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.hbc-preorder-trigger');
    if (!trigger) return;
    currentProductName = trigger.getAttribute('data-product') || '';
    currentProductId = trigger.getAttribute('data-product-id') || '';

    var labelEl = document.getElementById('hbc-modal-product-name');
    if (labelEl) labelEl.textContent = currentProductName;

    // Reset form state
    var formState = document.getElementById('hbc-modal-form-state');
    var successState = document.getElementById('hbc-modal-success-state');
    if (formState) formState.style.display = '';
    if (successState) successState.style.display = 'none';

    var errorEl = document.getElementById('hbc-modal-error');
    if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }

    var nameInput = document.getElementById('hbc-input-name');
    var waInput = document.getElementById('hbc-input-wa');
    if (nameInput) nameInput.value = '';
    if (waInput) waInput.value = '';

    modal.classList.add('hbc-modal-open');
    document.body.style.overflow = 'hidden';

    if (typeof qbxTrack === 'function') {
      qbxTrack('hobby_preorder_click', { product_id: currentProductId, product_title: currentProductName });
    }
  });

  // Close on backdrop click
  var backdrop = document.getElementById('hbc-modal-backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', function() {
      modal.classList.remove('hbc-modal-open');
      document.body.style.overflow = '';
    });
  }

  // Close on X button
  var closeBtn = document.getElementById('hbc-modal-close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      modal.classList.remove('hbc-modal-open');
      document.body.style.overflow = '';
    });
  }

  // Close on success close button
  var successCloseBtn = document.getElementById('hbc-modal-success-close-btn');
  if (successCloseBtn) {
    successCloseBtn.addEventListener('click', function() {
      modal.classList.remove('hbc-modal-open');
      document.body.style.overflow = '';
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('hbc-modal-open')) {
      modal.classList.remove('hbc-modal-open');
      document.body.style.overflow = '';
    }
  });

  // WA input — digits + dash only
  var waInput = document.getElementById('hbc-input-wa');
  if (waInput) {
    waInput.addEventListener('input', function() {
      this.value = this.value.replace(/[^0-9\-]/g, '');
    });
  }

  // Form submit
  var submitBtn = document.getElementById('hbc-modal-submit-btn');
  var form = document.getElementById('hbc-modal-form');
  if (form && submitBtn) {
    submitBtn.addEventListener('click', function() {
      var name = (document.getElementById('hbc-input-name') || {}).value || '';
      var waRaw = (document.getElementById('hbc-input-wa') || {}).value || '';
      var wa = waRaw.replace(/[^0-9]/g, '');
      var errorEl = document.getElementById('hbc-modal-error');

      name = name.trim();
      if (!name) {
        if (errorEl) { errorEl.textContent = 'Mohon isi nama lengkap kamu.'; errorEl.style.display = 'block'; }
        return;
      }
      if (wa.length < 8 || wa.length > 13) {
        if (errorEl) { errorEl.textContent = 'Nomor WhatsApp tidak valid. Masukkan 8-13 digit.'; errorEl.style.display = 'block'; }
        return;
      }
      if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Mengirim...';

      fetch('https://api.qbrix.co.id/api/preorder-lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Wheel-Token': '7adf4cd3eb08be12f493cc548e2d6de9093523e9227cd0d569c6a3c7b2d91591'
        },
        body: JSON.stringify({
          name: name,
          phone: '62' + wa,
          product_title: currentProductName,
          product_id: currentProductId
        })
      }).catch(function() {
        // Fire-and-forget — ignore network errors
      }).finally(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Konfirmasi Preorder →';

        if (typeof qbxTrack === 'function') {
          qbxTrack('hobby_preorder_submit', { product_id: currentProductId, product_title: currentProductName });
        }

        var formState = document.getElementById('hbc-modal-form-state');
        var successState = document.getElementById('hbc-modal-success-state');
        if (formState) formState.style.display = 'none';
        if (successState) { successState.style.display = 'flex'; }
      });
    });
  }
}

function hbcInitObservers() {
  // General hbc entrance
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { entry.target.classList.add('hbc-in-view'); io.unobserve(entry.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.hbc-observe').forEach(function(el) { io.observe(el); });

  // Catalog heading B3
  var catalogHeading = document.getElementById('hbc-catalog-heading');
  if (catalogHeading) {
    var ioHead = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('hbc-catalog-in-view'); ioHead.unobserve(entry.target); }
      });
    }, { threshold: 0.2 });
    ioHead.observe(catalogHeading);
  }

  // Crosssell animate-enter
  var enterObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { entry.target.classList.add('in-view'); enterObs.unobserve(entry.target); }
    });
  }, { threshold: 0 });
  document.querySelectorAll('.animate-enter').forEach(function(el) { enterObs.observe(el); });
}

function hbcTrackCollectionView() {
  if (typeof qbxTrack === 'function') {
    qbxTrack('hobby_collection_view', {});
  } else if (typeof fbq === 'function') {
    fbq('track', 'ViewContent', { content_name: 'Hobby Collection', content_type: 'product_group' });
  }
}

// ── PRODUCT PAGE FUNCTIONS ───────────────────────────────────────

// Gallery state
var hbpCurrentSlide = 0;
var hbpTotalSlides = 0;

function hbpSetSlide(idx) {
  var slides = document.querySelectorAll('.prod-gallery-slide');
  if (slides.length === 0) return;
  hbpCurrentSlide = (idx + slides.length) % slides.length;
  slides.forEach(function(slide, i) {
    slide.style.opacity = (i === hbpCurrentSlide) ? '1' : '0';
  });
  var thumbs = document.querySelectorAll('.thumb-btn');
  thumbs.forEach(function(btn, i) {
    btn.classList.toggle('active', i === hbpCurrentSlide);
  });
  var track = document.getElementById('prod-thumb-track');
  var activeThumb = thumbs[hbpCurrentSlide];
  if (track && activeThumb) {
    activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    setTimeout(hbpUpdateThumbArrows, 350);
  }
}

function hbpUpdateThumbArrows() {
  var track = document.getElementById('prod-thumb-track');
  if (!track) return;
  var prevBtn = document.getElementById('prod-thumb-prev');
  var nextBtn = document.getElementById('prod-thumb-next');
  var atStart = track.scrollLeft <= 4;
  var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  if (prevBtn) prevBtn.style.display = atStart ? 'none' : 'flex';
  if (nextBtn) nextBtn.style.display = atEnd ? 'none' : 'flex';
}

window.prodGalleryNext = function() { hbpSetSlide(hbpCurrentSlide + 1); };
window.prodGalleryPrev = function() { hbpSetSlide(hbpCurrentSlide - 1); };
window.prodSwitchSlide = function(idx) { hbpSetSlide(idx); };
window.prodThumbScroll = function(dir) {
  var track = document.getElementById('prod-thumb-track');
  if (!track) return;
  var firstChild = track.querySelector('*');
  var thumbWidth = firstChild ? firstChild.offsetWidth + 8 : 96;
  track.scrollLeft += dir * thumbWidth * 3;
  setTimeout(hbpUpdateThumbArrows, 350);
};

window.prodUpdateQty = function(change) {
  var input = document.getElementById('prod-qty');
  if (!input) return;
  var val = parseInt(input.value, 10) || 1;
  val = Math.min(99, Math.max(1, val + change));
  input.value = val;
};

function hbpInitGallery() {
  var slides = document.querySelectorAll('.prod-gallery-slide');
  hbpTotalSlides = slides.length;
  if (hbpTotalSlides === 0) return;

  // Touch swipe on main image
  var mainImg = document.getElementById('prod-main-img');
  if (mainImg) {
    var touchStartX = 0;
    var touchEndX = 0;
    mainImg.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    mainImg.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 50) window.prodGalleryNext();
      if (touchEndX - touchStartX > 50) window.prodGalleryPrev();
    });
  }

  // Thumb track scroll arrows
  setTimeout(hbpUpdateThumbArrows, 100);
  var thumbTrack = document.getElementById('prod-thumb-track');
  if (thumbTrack) {
    thumbTrack.addEventListener('scroll', hbpUpdateThumbArrows);
  }
}

function hbpInitFloatingCta() {
  var anchor = document.getElementById('prod-cta-anchor');
  var stickyCta = document.getElementById('prod-sticky-cta');
  if (!anchor || !stickyCta) return;
  var observer = new IntersectionObserver(function(entries) {
    var isVisible = entries[0].isIntersecting;
    if (isVisible) {
      stickyCta.classList.remove('visible');
    } else {
      stickyCta.classList.add('visible');
    }
  }, { threshold: 0 });
  observer.observe(anchor);
}

function hbpInitBreadcrumbs() {
  var nav = document.getElementById('breadcrumbs-nav');
  if (!nav) return;
  var bcObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        nav.classList.add('crumbs-played');
        bcObserver.unobserve(nav);
      }
    });
  }, { threshold: 0.5 });
  bcObserver.observe(nav);
}

function hbpInitTicker() {
  var inner = document.getElementById('prod-bene-ticker-inner');
  var group = document.getElementById('prod-bene-ticker-group');
  if (inner && group && !inner.dataset.cloned) {
    inner.appendChild(group.cloneNode(true));
    inner.dataset.cloned = '1';
  }
}

function hbpInitFeatAnim() {
  var featObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        featObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.hb-feat-anim').forEach(function(el) {
    featObs.observe(el);
  });
}

function hbpInitHdrObserve() {
  var hdrObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hdr-in-view');
        hdrObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  document.querySelectorAll('.hdr-observe').forEach(function(el) {
    hdrObserver.observe(el);
  });
}

function pad(n) { return String(n).padStart(2, '0'); }

function hbpInitPreorder() {
  var btnOpen = document.getElementById('po-btn-open');
  var btnStickyOpen = document.getElementById('po-sticky-btn-open');
  var btnClose = document.getElementById('po-modal-close');
  var overlay = document.getElementById('po-modal-overlay');
  if (!overlay) return;

  function openModal() {
    overlay.classList.add('po-modal-open');
    document.body.style.overflow = 'hidden';
    if (typeof qbxTrack === 'function') {
      var form = document.getElementById('po-preorder-form');
      qbxTrack('hobby_preorder_click', {
        product_id: form ? form.dataset.productId : '',
        product_title: form ? form.dataset.productTitle : ''
      });
    }
  }

  function closeModal() {
    overlay.classList.remove('po-modal-open');
    document.body.style.overflow = '';
  }

  if (btnOpen) btnOpen.addEventListener('click', openModal);
  if (btnStickyOpen) btnStickyOpen.addEventListener('click', openModal);
  if (btnClose) btnClose.addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  // Countdown timer (sessionStorage 2h per product)
  var TIMER_KEY = 'hbp_po_end_' + (window._hbpProductId || '');
  var DURATION_MS = 2 * 60 * 60 * 1000;
  var endTime = parseInt(sessionStorage.getItem(TIMER_KEY), 10);
  if (!endTime || endTime < Date.now()) {
    endTime = Date.now() + DURATION_MS;
    sessionStorage.setItem(TIMER_KEY, endTime);
  }
  var timerEl = document.getElementById('po-timer');
  if (timerEl) {
    var interval = setInterval(function() {
      var diff = Math.max(0, endTime - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      timerEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      if (diff === 0) clearInterval(interval);
    }, 1000);
  }
}

window.hbpPoSubmit = function(e) {
  e.preventDefault();
  var form = e.target || e.currentTarget;
  var nameEl = document.getElementById('po-name-input');
  var waInput = document.getElementById('po-wa-input');
  if (!nameEl || !waInput) return;
  var name = nameEl.value.trim();
  var raw = waInput.value.replace(/\D/g, '');
  if (raw.length < 9) {
    waInput.style.borderColor = '#E02F85';
    setTimeout(function() { waInput.style.borderColor = ''; }, 1500);
    return;
  }
  var phone = '62' + raw;
  var productId = form.dataset.productId;
  var productTitle = form.dataset.productTitle;
  var discountPct = parseInt(form.dataset.discountPct || '0', 10);

  fetch('https://api.qbrix.co.id/api/preorder-lead', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Wheel-Token': '7adf4cd3eb08be12f493cc548e2d6de9093523e9227cd0d569c6a3c7b2d91591'
    },
    body: JSON.stringify({
      name: name,
      phone: phone,
      product_id: productId,
      product_title: productTitle,
      discount_pct: discountPct,
      source: 'product-page'
    })
  }).catch(function() {});

  if (typeof qbxTrack === 'function') {
    qbxTrack('hobby_preorder_submit', {
      product_id: productId,
      product_title: productTitle,
      discount_pct: discountPct
    });
  }

  var formState = document.getElementById('po-form-state');
  var successState = document.getElementById('po-success-state');
  if (formState) formState.style.display = 'none';
  if (successState) successState.style.display = '';
};

function hbpParseDescription() {
  var productId = window._hbpProductId;
  if (!productId) return;
  var raw = document.getElementById('hb-desc-raw-' + productId);
  var container = document.getElementById('hb-desc-sections-' + productId);
  var wrap = document.getElementById('hb-desc-wrap-' + productId);
  if (!raw || !container || !wrap) return;

  if (container.children.length > 0) return;

  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = raw.innerHTML;

  var sections = [];
  var currentSection = null;

  tempDiv.querySelectorAll('p, h1, h2, h3, h4, ul, ol').forEach(function(el) {
    var text = el.textContent.trim();
    if (!text) return;
    // Detect emoji at start (basic range covers most common emoji)
    var emojiMatch = text.match(/^([\u{1F300}-\u{1FAFF}]|[\u{2600}-\u{27BF}])/u);
    if (emojiMatch) {
      var icon = emojiMatch[0];
      var title = text.slice(icon.length).trim();
      currentSection = { icon: icon, title: title, nodes: [] };
      sections.push(currentSection);
    } else if (currentSection) {
      // Transform <strong> → hb-desc-hl
      el.querySelectorAll('strong').forEach(function(s) {
        var hl = document.createElement('span');
        hl.className = 'hb-desc-hl';
        hl.textContent = s.textContent;
        s.replaceWith(hl);
      });
      el.querySelectorAll('em').forEach(function(s) {
        var hl = document.createElement('span');
        hl.className = 'hb-desc-hl-yellow';
        hl.textContent = s.textContent;
        s.replaceWith(hl);
      });
      el.querySelectorAll('u').forEach(function(s) {
        var hl = document.createElement('span');
        hl.className = 'hb-desc-hl-mint';
        hl.textContent = s.textContent;
        s.replaceWith(hl);
      });
      currentSection.nodes.push(el.cloneNode(true));
    }
  });

  // Render sections
  sections.forEach(function(sec, i) {
    var div = document.createElement('div');
    div.className = 'hb-desc-section-v2' + (i >= 2 ? ' hb-desc-hidden-v2' : '');
    var content = document.createElement('div');
    content.className = 'hb-desc-section-content';
    sec.nodes.forEach(function(n) { content.appendChild(n); });
    div.innerHTML =
      '<div class="hb-desc-icon-v2">' + sec.icon + '</div>' +
      '<div class="hb-desc-section-body-v2">' +
        '<div class="hb-desc-subhead-v2">' + sec.title + '</div>' +
      '</div>';
    div.querySelector('.hb-desc-section-body-v2').appendChild(content);
    container.appendChild(div);
  });

  // Show expand row if there are hidden sections
  if (sections.length > 2) {
    var expandRow = document.getElementById('hb-desc-expand-row-' + productId);
    if (expandRow) expandRow.style.display = '';
  }

  // Hide entire section if no cards were rendered (description has no emoji headings)
  if (container.children.length === 0) {
    var sectionWrap = wrap.closest('.hb-desc-section-wrap');
    if (sectionWrap) sectionWrap.style.display = 'none';
  }
}

function hbpTrackHobbyView() {
  var isPreorder = !!document.getElementById('po-btn-open');
  var pid = window._hbpProductId || '';
  var ptitle = window._hbpProductTitle || '';
  if (typeof qbxTrack === 'function') {
    qbxTrack('hobby_view', { product_id: pid, product_title: ptitle, is_preorder: isPreorder });
  }
  if (typeof fbq === 'function') {
    fbq('track', 'ViewContent', { content_name: ptitle, content_ids: [pid], content_type: 'product' });
  }
}

window.hbpTrackVideoPlay = function(el) {
  if (typeof qbxTrack === 'function') {
    qbxTrack('hobby_video_play', {
      product_id: window._hbpProductId || '',
      product_title: window._hbpProductTitle || ''
    });
  }
};

function hbpInitRelated() {
  var section = document.getElementById('related-products-section');
  if (!section) return;
  var url = section.getAttribute('data-url');
  if (!url) return;
  // Section already rendered server-side via recommendations — AJAX fallback for storefront rendering
  // If already has content, skip AJAX
  if (section.querySelector('.hp-rel-grid')) return;
  fetch(url)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var inner = doc.querySelector('#related-products-section');
      if (inner && inner.innerHTML.trim()) {
        section.innerHTML = inner.innerHTML;
      }
    })
    .catch(function() {});
}

function hbpInitBuyNow() {
  var btn = document.getElementById('prod-buy-btn');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var variantInput = document.getElementById('prod-variant-id');
    var qtyInput = document.getElementById('prod-qty');
    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!variantId) return;
    btn.disabled = true;
    btn.style.opacity = '0.7';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      var atcBtn = document.getElementById('prod-atc-btn');
      if (typeof qbxTrack === 'function' && atcBtn) {
        qbxTrack('add_to_cart', {
          currency: atcBtn.dataset.currency,
          value: parseInt(atcBtn.dataset.price, 10) / 100,
          items: [{ item_id: atcBtn.dataset.productId, item_name: atcBtn.dataset.productTitle,
                    price: parseInt(atcBtn.dataset.price, 10) / 100, quantity: qty }]
        });
      }
      window.location.href = '/cart';
    })
    .catch(function() {
      btn.disabled = false;
      btn.style.opacity = '';
    });
  });
}

// prodDescToggle — reuse same function from qbrix-product.js pattern
// On hobby page qbrix-product.js is NOT loaded — define here
if (!window.prodDescToggle) {
  window.prodDescToggle = function(e) {
    e.preventDefault();
    var target = document.getElementById('hb-desc-section');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
}
